import { UnidataUrlData } from '../../libs/controls/Grid/interfaces';
import { buildUrl } from '../../libs/helpers/Utils';

interface UrlBuilderProps {
  urlData?: UnidataUrlData;
  fieldValues: Array<{
    controlid: string;
    value: any;
  }>;
  api: any;
}

export const urlBuilder = ({ api, urlData, fieldValues }: UrlBuilderProps) => {
  let dataUrlSubstituted = urlData?.url;
  let allOptions = { ...api.options } as Record<string, string>;

  /**
   * в extra.urlBuilder все параметры и то, как их нужно заменить
   * заполняем allOptions в зависимости от того, что указано в extra.urlBuilder
   */
  if (typeof urlData?.extra?.urlBuilder === 'object') {
    Object.entries(urlData?.extra?.urlBuilder).forEach(
      ([fieldId, fieldFillRule]) => {
        let valueToFill;
        switch (true) {
          case !!fieldFillRule.controlId:
            valueToFill = fieldValues.find(
              ({ controlid }) => controlid === fieldFillRule.controlId,
            )?.value;
            break;
          default:
            break;
        }
        if (!!valueToFill) allOptions[fieldId] = valueToFill;
      },
    );
  }

  if (urlData?.url) {
    dataUrlSubstituted = buildUrl(urlData.url, allOptions);
  }

  console.log(dataUrlSubstituted);

  return dataUrlSubstituted;
};
